import { useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList, Loader2, Users, X } from "lucide-react";
import { WhatsAppGlyph } from "@/components/cards/CardShell";
import { fetchMySalons, ron } from "@/lib/bf";
import { fetchUsers } from "@/lib/api";
import { waLink } from "@/lib/wa";
import BFAssign from "./BFAssign";
import BFContractDot from "./BFContractDot";

const when = (iso) => new Date(iso).toLocaleString("ro-RO", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const HELLO = "Bună ziua! Vă mulțumesc că v-ați înscris la Black Friday Beauty Trends. Vă pot ajuta cu comanda?";
const nudge = (s) => `Bună ziua${s.admin_name ? `, ${s.admin_name}` : ""}! Contul salonului ${s.salon || ""} la Black Friday Beauty Trends 2026 este activ, dar nu ați trimis încă nicio comandă. Ofertele sunt în limita stocului disponibil, primul venit primul servit. Comandați aici: ${window.location.origin}/blackfriday · Vă pot ajuta cu alegerea produselor?`;

const Row = ({ s, agents, onMoved }) => (
  <li className={`${agents && !s.agent ? "is-unassigned" : ""} ${s.neglected ? "is-neglected" : ""}`} data-testid={`bf-my-salon-${s.id}`}>
    <div className="bf-mysalons-main">
      <b><BFContractDot state={s.contract_state} testid={`bf-my-salon-contract-${s.id}`} /> {s.salon || "Salon"} {agents && !s.agent && <span className="bf-red-tag" data-testid={`bf-my-salon-unassigned-${s.id}`}>Fără agent</span>}{s.neglected && <span className="bf-red-tag" data-testid={`bf-my-salon-neglected-${s.id}`}>Nevizitat de peste o lună</span>}</b>
      <small>{[s.admin_name, s.city, s.cui && `CUI ${s.cui}`].filter(Boolean).join(" · ")}</small>
      <small>{[s.phone, s.email].filter(Boolean).join(" · ")}</small>
    </div>
    <div className="bf-mysalons-side">
      <em data-testid={`bf-my-salon-date-${s.id}`}>cont creat {when(s.created_at)}</em>
      <span className={s.orders ? "" : "bf-noorder"} data-testid={`bf-my-salon-orders-${s.id}`}>{s.orders ? `${s.orders} ${s.orders === 1 ? "comandă" : "comenzi"} · ${ron(s.ordered)}` : "fără comandă încă"}</span>
      <Link className="st-btn st-btn--light" to={`/client/${s.id}`} data-testid={`bf-my-salon-card-${s.id}`}><ClipboardList size={14} /> Fișă client</Link>
      {waLink(s.phone, HELLO) && (s.orders
        ? <a className="st-btn st-btn--ghost" href={waLink(s.phone, HELLO)} target="_blank" rel="noopener noreferrer" data-testid={`bf-my-salon-wa-${s.id}`}><WhatsAppGlyph /> Scrie-i</a>
        : <a className="st-btn bf-nudge" href={waLink(s.phone, nudge(s))} target="_blank" rel="noopener noreferrer" data-testid={`bf-my-salon-nudge-${s.id}`}><WhatsAppGlyph /> Reamintește-i comanda</a>
      )}
      {agents && <BFAssign s={s} agents={agents} onMoved={onMoved} />}
    </div>
  </li>
);

export default function BFMySalons({ admin = false }) {
  const [rows, setRows] = useState(null);
  const [agents, setAgents] = useState(null);
  const [busy, setBusy] = useState(false);
  const [only, setOnly] = useState(false);
  const open = () => {
    setBusy(true);
    if (admin) fetchUsers().then((d) => setAgents(d.users.filter((u) => (u.role === "agent" || u.role === "admin") && u.share_slug))).catch(() => {});
    fetchMySalons().then(setRows).catch(() => setRows([])).finally(() => setBusy(false));
  };
  const moved = (id) => setRows((l) => l.filter((x) => x.id !== id));
  if (!rows) return (
    <button type="button" className="st-btn st-btn--light" onClick={open} disabled={busy} data-testid="bf-my-salons-open">
      {busy ? <Loader2 size={14} className="animate-spin" /> : <Users size={14} />} Clienții mei înscriși
    </button>
  );
  return (
    <div className="bf-mysalons" data-testid="bf-my-salons">
      <div className="bf-mysalons-head">
        <div className="st-section-title"><Users size={12} /> Clienții mei înscriși ({rows.length}) · de la cel mai nou</div>
        <button type="button" className="st-btn st-btn--ghost" onClick={() => setRows(null)} data-testid="bf-my-salons-close"><X size={14} /> Ascunde</button>
      </div>
      {rows.length > 0 && (
        <div className="bf-mysalons-filter" role="tablist">
          <button type="button" className={!only ? "is-on" : ""} onClick={() => setOnly(false)} data-testid="bf-my-salons-all">Toți ({rows.length})</button>
          <button type="button" className={only ? "is-on" : ""} onClick={() => setOnly(true)} data-testid="bf-my-salons-noorder">Fără comandă ({rows.filter((x) => !x.orders).length})</button>
        </div>
      )}
      {!rows.length && <p className="st-hint" data-testid="bf-my-salons-empty">Niciun salon nu și-a făcut încă cont prin linkul tău.</p>}
      {only && rows.length > 0 && !rows.some((x) => !x.orders) && <p className="st-hint" data-testid="bf-my-salons-noorder-empty">Toți clienții tăi au trimis deja cel puțin o comandă.</p>}
      <ul>{rows.filter((x) => !only || !x.orders).map((s) => <Row key={s.id} s={s} agents={agents} onMoved={moved} />)}</ul>
    </div>
  );
}
